import { render } from "./PopUpEditFile.vue?vue&type=template&id=2b19dba2"
import script from "./PopUpEditFile.vue?vue&type=script&lang=js"
export * from "./PopUpEditFile.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__